import {DispatchEntity} from "@ots-frontend/ots-data";
import {useEntityDataGrid, UseEntityDataGridProps, UseEntityDataGridResult} from "../../EntityDataGrid/useEntityDataGrid";
import {useDispatchDataGridCols} from "./useDispatchDataGridCols";

export const EMPTY_ARRAY: DispatchEntity[] = []

export type UseDispatchDataGridProps = Omit<UseEntityDataGridProps<DispatchEntity>, 'colsMap'>

export function useDispatchDataGrid(props: UseDispatchDataGridProps): UseEntityDataGridResult<DispatchEntity> {
  const {data = EMPTY_ARRAY, colWidths, ...rest} = props;

  const {colsMap} = useDispatchDataGridCols({colWidths: colWidths})

  return useEntityDataGrid<DispatchEntity>({
    ...rest,
    colsMap: colsMap.filter(column => column.defaultVisible !== false),
    colWidths: colWidths,
    data: data,
  })
}
